import * as ProgressPrimitive from "@radix-ui/react-progress";
import styles from "./ProgressBar.module.scss";

interface ProgressBarProps {
  currentValue: number;
  maxValue: number;
}

function ProgressBar({ currentValue, maxValue }: ProgressBarProps) {
  const progressRatio = currentValue / maxValue;

  return (
    <ProgressPrimitive.Root
      className={styles.progressBarBackground}
      value={currentValue}
      max={maxValue}
    >
      <ProgressPrimitive.Indicator
        className={styles.progressBar}
        style={{ width: `${progressRatio * 100}%` }}
      />
    </ProgressPrimitive.Root>
  );
}

export default ProgressBar;
